import React from 'react';
import { compose } from 'recompose';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import withStdForm from 'data/StdForm';
import StdFormDialog from 'components/Dialogs/StdFormDialog';
import {useStyles} from 'components/Dialogs/HelpSupportDialog/styles';
import { getDatasetId } from 'utils/auth/selectors';
import { getDatasetsById } from 'data/datasets/selectors';
import videoImage from 'assets/help-video.png';
import supportImage from 'assets/help-support.png';


const HelpSupport = () => {
  const classes = useStyles();
  const datasetId = useSelector(getDatasetId);
  const datasetsById = useSelector(getDatasetsById);
  const currentDataset = datasetId && datasetsById.get(datasetId);
  const showVideoSection = ['QWIN_MWF', 'QMAC_MWF', 'QWIN_CA_MWF'].includes(currentDataset?.platform);

  return (
    <StdFormDialog
      dialogProps={{
        fullWidth: true,
        maxWidth: showVideoSection ? 'md' : 'sm',
      }}
      showCloseButton>
      <Grid container className={classes.root}>
        <Grid item className={classes.supportSectionRoot}>
          <div className={classes.title}>Support</div>
          <div className={classes.mediaHolder}>
            <img src={supportImage} alt="Support"/>
          </div>
          <div className={classes.content}>
            <p>
              Visit <Link target="_blank" href="http://quicken.com/contact-support">www.quicken.com/contact-support</Link> or
              call us at 650-250-1900 during office hours Mon - Fri, 5 AM to 5 PM (Pacific)
            </p>
          </div>
        </Grid>
        {showVideoSection && (
          <Grid item className={classes.videoSectionRoot}>
            <div className={classes.title}>Videos</div>
            <div className={classes.mediaHolder}>
              <img src={videoImage} alt="Video"/>
            </div>
            <div className={classes.content}>
              <p>Learn how to use Quicken <br/>from our video library</p>
              <Link target="_blank" href="https://www.youtube.com/user/Quicken/videos">Go to Videos</Link>
            </div>
          </Grid>
        )}
      </Grid>
    </StdFormDialog>
  );
};

HelpSupport.propTypes = {};

export default compose(
  withStdForm({ type: 'HelpSupport' })
)(HelpSupport);
